import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import CategoryList from './CategoryList';
import FilterToolbar from '../Misc/FilterToolbar';
import ListPagination from '../Misc/ListPagination';
import TextInputBox from '../TextInputBox';

export default class CategoryListView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            categories: [],
            filter: ['Active'],
            searchText: ""
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.categories !== this.props.categories) this.setState({ categories: this.getCategories(this.state.filter) });
        if (prevState.searchText !== this.state.searchText) this.setState({ categories: this.getCategories(this.state.filter) });
        if (prevState.filter !== this.state.filter) this.setState({ categories: this.getCategories(this.state.filter) });
    }

    handleEditCategory = (category) => {
        this.props.onEditCategory(category);
    }

    handleToggleFilter = (filter) => {
        this.setState({ filter });
    }

    handleSearch = (text) => {
        this.setState({ searchText: text.toLowerCase() });
    }

    getThemePackage = (id) => {
        var themePackages = this.props.themePackages.filter(x => x.id === id);
        return themePackages.length > 0 ? themePackages[0] : null;
    }

    getCategories = (filter = [], search = "") => {
        let categories = this.props.categories.slice();
        let toDisplay = this.getCategoriesToDisplay(filter).map(x => x.code);
        categories = categories.filter(x => toDisplay.includes(x.code));
        if (this.state.searchText !== "")
            categories = categories.filter(x => x.name.toLowerCase().includes(this.state.searchText) || x.code.toLowerCase().includes(this.state.searchText));
        return categories;
    }

    getCategoriesToDisplay = (filter) => {
        let categories = [...this.props.categories];
        for (let i = 0; i < filter.length; i++) {
            switch (filter[i]) {
                case 'Active': categories = categories.filter(x => x.isActive); break;
                case 'Inactive': categories = categories.filter(x => !x.isActive); break;
                case 'Available': categories = categories.filter(x => x.isAvailable); break;
                case 'Unavailable': categories = categories.filter(x => !x.isAvailable); break;
            }
        }

        return categories;
    }

    render() {
        return (
            <Grid fluid>
                <Row>
                    <Col sm={12}>
                        <TextInputBox placeholder={"Search..."} onChange={this.handleSearch} />
                        <FilterToolbar items={['Active', 'Inactive', 'Available', 'Unavailable']} defaultValues={[0]} onToggle={this.handleToggleFilter} />
                        <ListPagination
                            items={this.state.categories}
                            itemsPerPage={25}
                        >
                            <CategoryList
                                packageId={this.props.packageId}
                                isLoading={this.props.isLoading}
                                onEditCategory={this.handleEditCategory}
                            />
                        </ListPagination>
                    </Col>
                </Row>
            </Grid>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/CategoryView/CategoryListView.js